module.exports = __webpack_public_path__ + "fonts/cJZKeOuBrn4kERxqtaUH3ZBw1xU1rKptJj_0jans920.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/content/fonts/Sans/cJZKeOuBrn4kERxqtaUH3ZBw1xU1rKptJj_0jans920.woff2
// module id = 384
// module chunks = 0